<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm-title" id="fm-3"><a id="page_xii"><strong><em>Abbreviations</em></strong></a></h1><a id="page_xii">
<h1 class="sec1"><strong>I. JOURNALS, PERIODICALS, REFERENCE WORKS, AND SERIES</strong></h1>
<table>
<tbody>
<tr>
<td class="col30"><p class="t-hang">AB</p></td>
<td class="col65"><p class="t-hang">Anchor Bible</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">AnBib</p></td>
<td class="col65"><p class="t-hang">Analecta biblica</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">ANTC</p></td>
<td class="col65"><p class="t-hang">Abingdon New Testament Commentaries or Augsburg New Testament Commentary</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>APOT</em></p></td>
<td class="col65"><p class="t-hang"><em>Apocrypha and Pseudepigrapha of the Old Testament,</em> by R. H. Charles</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">BAG</p></td>
<td class="col65"><p class="t-hang">W. Bauer, W. F. Arndt, and F. W. Gingrich, <em>A Greek-English Lexicon of The New Testament and Other Early Christian Literature</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>BBR</em></p></td>
<td class="col65"><p class="t-hang"><em>Bulletin for Biblical Research</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">BDF</p></td>
<td class="col65"><p class="t-hang">F. Blass, A. Debrunner, and R. W. Funk, <em>A Greek Grammar of the New Testament and Other Early Christian Literature</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">BETL</p></td>
<td class="col65"><p class="t-hang">Bibliotheca ephemeridum theologicarum lovaniensium</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">BFCT</p></td>
<td class="col65"><p class="t-hang">Beiträge zur Förderung christlicher Theologie</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>Bib</em></p></td>
<td class="col65"><p class="t-hang"><em>Biblica</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">BNTC</p></td>
<td class="col65"><p class="t-hang">Black’s New Testament Commentaries</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>BSac</em></p></td>
<td class="col65"><p class="t-hang"><em>Bibliotheca sacra</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">BTN</p></td>
<td class="col65"><p class="t-hang">Biblica Theologica Norvegica</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>BZ</em></p></td>
<td class="col65"><p class="t-hang"><em>Biblische Zeitschrift</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">BZNW</p></td>
<td class="col65"><p class="t-hang">Beihefte zur Zeitschrift für die neutestamentliche Wissenschaft</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>CBQ</em></p></td>
<td class="col65"><p class="t-hang"><em>Catholic Biblical Quarterly</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><a id="page_xiii">CBSC</a></p></td>
<td class="col65"><p class="t-hang">Cambridge Bible for Schools and Colleges</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">CEJL</p></td>
<td class="col65"><p class="t-hang">Commentaries on Early Jewish Literature</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">CGTSC</p></td>
<td class="col65"><p class="t-hang">Cambridge Greek Testament for Schools and Colleges</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">ConNT</p></td>
<td class="col65"><p class="t-hang">Coniectanea biblica: New Testament Series</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>CTJ</em></p></td>
<td class="col65"><p class="t-hang"><em>Calvin Theological Journal</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>DLNT</em></p></td>
<td class="col65"><p class="t-hang"><em>Dictionary of the Later New Testament and Its Developments</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>DPL</em></p></td>
<td class="col65"><p class="t-hang"><em>Dictionary of Paul and His Letters</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">EB</p></td>
<td class="col65"><p class="t-hang">Etudes bibliques</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">EKK</p></td>
<td class="col65"><p class="t-hang">Evangelische-katholischer Kommentar</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>EvQ</em></p></td>
<td class="col65"><p class="t-hang"><em>Evangelical Quarterly</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>ExpT</em></p></td>
<td class="col65"><p class="t-hang"><em>Expository Times</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">HNT</p></td>
<td class="col65"><p class="t-hang">Handbuch zum Neuen Testament</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">HTKNT</p></td>
<td class="col65"><p class="t-hang">Herders theologischer Kommentar zum Neuen Testament</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>HTR</em></p></td>
<td class="col65"><p class="t-hang"><em>Harvard Theological Review</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">ICC</p></td>
<td class="col65"><p class="t-hang">International Critical Commentary</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>JBL</em></p></td>
<td class="col65"><p class="t-hang"><em>Journal of Biblical Literature</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>JETS</em></p></td>
<td class="col65"><p class="t-hang"><em>Journal of the Evangelical Theological Society</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>JNES</em></p></td>
<td class="col65"><p class="t-hang"><em>Journal of Near Eastern Studies</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>JSJ</em></p></td>
<td class="col65"><p class="t-hang"><em>Journal for the Study of Judaism</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>JSNT</em></p></td>
<td class="col65"><p class="t-hang"><em>Journal for the Study of the New Testament</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>JSOT</em></p></td>
<td class="col65"><p class="t-hang"><em>Journal for the Study of the Old Testament</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">L&amp;S</p></td>
<td class="col65"><p class="t-hang">H. D. Liddell and R. Scott, <em>A Greek-English Lexicon</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">MNTC</p></td>
<td class="col65"><p class="t-hang">Moffatt New Testament Commentary</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">MSGVK</p></td>
<td class="col65"><p class="t-hang">Mitteilungen der schlesischen Gesellschaft für Volkskunde</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">NAC</p></td>
<td class="col65"><p class="t-hang">New American Commentary</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">NCB</p></td>
<td class="col65"><p class="t-hang">New Century Bible</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">NIBC</p></td>
<td class="col65"><p class="t-hang">New International Biblical Commentary</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">NICNT</p></td>
<td class="col65"><p class="t-hang">New International Commentary on the New Testament</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">NIGTC</p></td>
<td class="col65"><p class="t-hang">New International Greek Testament Commentary</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">NovTSup</p></td>
<td class="col65"><p class="t-hang">Novum Testamentum Supplements</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">NTD</p></td>
<td class="col65"><p class="t-hang">Das Neue Testament Deutsch</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>NTS</em></p></td>
<td class="col65"><p class="t-hang"><em>New Testament Studies</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>OTP</em></p></td>
<td class="col65"><p class="t-hang"><em>Old Testament Pseudepigrapha,</em> edited by James H. Charlesworth</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>RB</em></p></td>
<td class="col65"><p class="t-hang"><em>Revue biblique</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">SB</p></td>
<td class="col65"><p class="t-hang">Sources bibliques</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">SBLDS</p></td>
<td class="col65"><p class="t-hang">Society of Biblical Literature Dissertation Series</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><a id="page_xiv">SBLSCS</a></p></td>
<td class="col65"><p class="t-hang">Society of Biblical Literature Septuagint and Cognate Studies</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">SBT</p></td>
<td class="col65"><p class="t-hang">Studies in Biblical Theology</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>Scr</em></p></td>
<td class="col65"><p class="t-hang"><em>Scripture</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">SD</p></td>
<td class="col65"><p class="t-hang">Studies and Documents</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>ST</em></p></td>
<td class="col65"><p class="t-hang"><em>Studia Theologica</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">SVTP</p></td>
<td class="col65"><p class="t-hang">Studia in Veteris Testamenti pseudepigrapha</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>TDNT</em></p></td>
<td class="col65"><p class="t-hang"><em>Theological Dictionary of the New Testament</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>TLZ</em></p></td>
<td class="col65"><p class="t-hang"><em>Theologische Literaturzeitung</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">TNTC</p></td>
<td class="col65"><p class="t-hang">Tyndale New Testament Commentaries</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">TU</p></td>
<td class="col65"><p class="t-hang">Texte und Untersuchungen</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>TynBul</em></p></td>
<td class="col65"><p class="t-hang"><em>Tyndale Bulletin</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>TZ</em></p></td>
<td class="col65"><p class="t-hang"><em>Theologische Zeitschrift</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">WBC</p></td>
<td class="col65"><p class="t-hang">Word Biblical Commentary</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>WTJ</em></p></td>
<td class="col65"><p class="t-hang"><em>Westminster Theological Journal</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">WUNT</p></td>
<td class="col65"><p class="t-hang">Wissenschaftliche Untersuchungen zum Neuen Testament</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>ZNW</em></p></td>
<td class="col65"><p class="t-hang"><em>Zeitschrift für die neutestamentliche Wissenschaft und die Kunde der älteren Kirche</em></p></td>
</tr>
</tbody>
</table>
<h1 class="sec1"><strong>II. BIBLE TRANSLATIONS</strong></h1>
<table>
<tbody>
<tr>
<td class="col30"><p class="t-hang">ASV</p></td>
<td class="col65"><p class="t-hang">American Standard Version (1901)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">ESV</p></td>
<td class="col65"><p class="t-hang">English Standard Version</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">GNB</p></td>
<td class="col65"><p class="t-hang">Good News Bible</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">JB</p></td>
<td class="col65"><p class="t-hang">Jerusalem Bible</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">KJV</p></td>
<td class="col65"><p class="t-hang">King James Version</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">LXX</p></td>
<td class="col65"><p class="t-hang">Septuagint, i.e. the main Greek translation of the Hebrew Scriptures</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">NAB</p></td>
<td class="col65"><p class="t-hang">New American Bible</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">NASV</p></td>
<td class="col65"><p class="t-hang">New American Standard Version</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">NEB</p></td>
<td class="col65"><p class="t-hang">New English Bible</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">NET Bible</p></td>
<td class="col65"><p class="t-hang">New English Translation (©1996, Biblical Studies Press)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">NKJV</p></td>
<td class="col65"><p class="t-hang">New King James Version</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">NIV</p></td>
<td class="col65"><p class="t-hang">New International Version</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">NLV</p></td>
<td class="col65"><p class="t-hang">New Living Version</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">NRSV</p></td>
<td class="col65"><p class="t-hang">New Revised Standard Version</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">RSV</p></td>
<td class="col65"><p class="t-hang">Revised Standard Version</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">RV</p></td>
<td class="col65"><p class="t-hang">English Revised Version</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">TEV</p></td>
<td class="col65"><p class="t-hang">Today’s English Version (1966)</p></td>
</tr>
</tbody>
</table>
</a><h1 class="sec1"><a id="page_xii"></a><a id="page_xv"><strong>III. APOCRYPHA</strong></a></h1><a id="page_xv">
<p class="para">Because they are part of the Septuagint, and thus part of the Bible of the early Jesus movement, the Apocrypha are cited in the same manner as any other biblical book.</p>
<table>
<tbody>
<tr>
<td class="col30"><p class="t-hang">1 Esdr</p></td>
<td class="col65"><p class="t-hang">First Esdras</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">2 Esdr</p></td>
<td class="col65"><p class="t-hang">Second Esdras</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Jdt</p></td>
<td class="col65"><p class="t-hang">Judith</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">1 Macc</p></td>
<td class="col65"><p class="t-hang">First Maccabees</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">2 Macc</p></td>
<td class="col65"><p class="t-hang">Second Maccabees</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">3 Macc.</p></td>
<td class="col65"><p class="t-hang">Third Maccabees</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">4 Macc.</p></td>
<td class="col65"><p class="t-hang">Fourth Maccabees</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Sir</p></td>
<td class="col65"><p class="t-hang">Sirach, or the Wisdom of Jesus ben Sira, or Ecclesiasticus</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Tob</p></td>
<td class="col65"><p class="t-hang">Tobit</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Wisd</p></td>
<td class="col65"><p class="t-hang">Wisdom of Solomon</p></td>
</tr>
</tbody>
</table>
<h1 class="sec1"><strong>IV. PSEUDEPIGRAPHA</strong></h1>
<table>
<tbody>
<tr>
<td class="col30"><p class="t-hang"><em>A</em><span class="char">ḥ</span><em>ikar</em></p></td>
<td class="col65"><p class="t-hang"><em>A</em><span class="char">ḥ</span><em>iqar (The Words of A</em><span class="char">ḥ</span><em>iqar) or A</em><span class="char">ḥ</span><em>ikar</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>1 Enoch</em></p></td>
<td class="col65"><p class="t-hang"><em>First (Ethiopic) Enoch</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>2 Enoch</em></p></td>
<td class="col65"><p class="t-hang"><em>Second (Slavonic) Enoch</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>2 Apoc. Bar.</em></p></td>
<td class="col65"><p class="t-hang"><em>Second Apocalypse of Baruch</em> (also called <em>2 Bar.</em>)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>3 Apoc. Bar.</em></p></td>
<td class="col65"><p class="t-hang"><em>Third Apocalypse of Baruch</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>Asc. Isa.</em></p></td>
<td class="col65"><p class="t-hang"><em>Ascension of Isaiah</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>4 Ezra</em></p></td>
<td class="col65"><p class="t-hang"><em>Fourth Ezra</em> (an expanded form of 2 Esdr)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>Jub.</em></p></td>
<td class="col65"><p class="t-hang"><em>Jubilees</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>Paral. Jer.</em></p></td>
<td class="col65"><p class="t-hang"><em>Paraleipomena Jeremiou</em> (<em>Things Omitted from Jeremiah,</em> also known as <em>4 Bar.</em>)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>Pss. Sol.</em></p></td>
<td class="col65"><p class="t-hang"><em>Psalms of Solomon</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>Sib. Or.</em></p></td>
<td class="col65"><p class="t-hang"><em>Sibylline Oracles</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>Test. Abr.</em></p></td>
<td class="col65"><p class="t-hang"><em>Testament of Abraham</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>Test. Moses</em></p></td>
<td class="col65"><p class="t-hang"><em>Testament of Moses</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>T. Ash.</em></p></td>
<td class="col65"><p class="t-hang"><em>Testament of Asher</em> in the <em>Testaments of the Twelve Patriarchs</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>T. Benj.</em></p></td>
<td class="col65"><p class="t-hang"><em>Testament of Benjamin</em> in the <em>Testaments of the Twelve Patriarchs</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>T. Jud.</em></p></td>
<td class="col65"><p class="t-hang"><em>Testament of Judah</em> in the <em>Testaments of the Twelve Patriarchs</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><a id="page_xvi"><em>T. Levi</em></a></p></td>
<td class="col65"><p class="t-hang"><em>Testament of Levi</em> in the <em>Testaments of the Twelve Patriarchs</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>T. Naph.</em></p></td>
<td class="col65"><p class="t-hang"><em>Testament of Naphtali</em> in the <em>Testaments of the Twelve Patriarchs</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>T. Reub.</em></p></td>
<td class="col65"><p class="t-hang"><em>Testament of Reuben</em> in the <em>Testaments of the Twelve Patriarchs</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>T. Zeb.</em></p></td>
<td class="col65"><p class="t-hang"><em>Testament of Zebulun</em> in the <em>Testaments of the Twelve Patriarchs</em></p></td>
</tr>
</tbody>
</table>
<h1 class="sec1"><strong>V. DEAD SEA SCROLLS</strong></h1>
<table>
<tbody>
<tr>
<td class="col30"><p class="t-hang">1QapGen</p></td>
<td class="col65"><p class="t-hang">The <em>Genesis Apocryphon</em> from Cave 1 in Qumran</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">1QH</p></td>
<td class="col65"><p class="t-hang">The <em>Thanksgiving</em> scroll from Cave 1 in Qumran</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">1QM</p></td>
<td class="col65"><p class="t-hang">The <em>War</em> scroll from Cave 1 in Qumran</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">1QpHab</p></td>
<td class="col65"><p class="t-hang"><em>Commentary (Pesher) on Habakkuk</em> from Cave 1 in Qumran</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">1QPs<sup>a</sup>Zion</p></td>
<td class="col65"><p class="t-hang"><em>Psalms of Zion</em> scroll from Cave 1 in Qumran</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">1QS</p></td>
<td class="col65"><p class="t-hang">The <em>Rule of the Community</em> from Cave 1 in Qumran</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">1QSa</p></td>
<td class="col65"><p class="t-hang">The <em>Rule of the Congregation</em> or <em>Messianic Rule</em> from Cave 1 of Qumran</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">4QAmram</p></td>
<td class="col65"><p class="t-hang">The scroll about Amram from Cave 4 of Qumran</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">4QEn<sup>a</sup></p></td>
<td class="col65"><p class="t-hang">4QEnoch<sup>a</sup></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">4QEn<sup>c</sup></p></td>
<td class="col65"><p class="t-hang">4QEnoch<sup>c</sup></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">4QEnGiants<sup>a</sup></p></td>
<td class="col65"><p class="t-hang">Aramaic Fragments of <em>1 Enoch</em> from the <em>Book of Giants</em> from Cave 4 of Qumran (4Q203)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">4QFlor</p></td>
<td class="col65"><p class="t-hang"><em>Florilegium</em> from Cave 4 of Qumran</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">4QpNah</p></td>
<td class="col65"><p class="t-hang"><em>Commentary (Pesher) on Nahum</em> from Cave 4 in Qumran</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">4QTest [4Q175]</p></td>
<td class="col65"><p class="t-hang"><em>Testimonia</em> from Cave 4 of Qumran</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">CD</p></td>
<td class="col65"><p class="t-hang">Cairo <em>Damascus Document</em></p></td>
</tr>
</tbody>
</table>
<h1 class="sec1"><strong>VI. RABBINIC WRITINGS</strong></h1>
<table>
<tbody>
<tr>
<td class="col30"><p class="t-hang"><em>m. Abot</em></p></td>
<td class="col65"><p class="t-hang"><em>Mishnah</em> tractate <em>Abot</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>m. Sanh.</em></p></td>
<td class="col65"><p class="t-hang"><em>Mishnah</em> tractate <em>Sanhedrin</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>m. Sot.</em></p></td>
<td class="col65"><p class="t-hang"><em>Mishnah</em> tractate <em>Sotah</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>b. B. Bat.</em></p></td>
<td class="col65"><p class="t-hang"><em>Babylonian Talmud,</em> tractate <em>Baba Bathra</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>b. Hag.</em></p></td>
<td class="col65"><p class="t-hang"><em>Babylonian Talmud,</em> tractate <em>Hagigah</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><a id="page_xvii"><em>b. Kidd.</em></a></p></td>
<td class="col65"><p class="t-hang"><em>Babylonian Talmud,</em> tractate <em>Kiddushin</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>b. Menah.</em></p></td>
<td class="col65"><p class="t-hang"><em>Babylonian Talmud,</em> tractate <em>Menahoth</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>b. Mes</em><span class="char">ʿ</span><em>ia</em></p></td>
<td class="col65"><p class="t-hang"><em>Babylonian Talmud,</em> tractate <em>Mes</em><span class="char">ʿ</span><em>ia</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>b. Sanh.</em></p></td>
<td class="col65"><p class="t-hang"><em>Babylonian Talmud,</em> tractate <em>Sanhedrin</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>b. Yoma</em></p></td>
<td class="col65"><p class="t-hang"><em>Babylonian Talmud,</em> tractate <em>Yoma</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>y. Ta</em><span class="char">ʿ</span><em>an.</em></p></td>
<td class="col65"><p class="t-hang"><em>Jerusalem Talmud,</em> tractate <em>Ta</em><span class="char">ʿ</span><em>anit</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>Gen. R.</em></p></td>
<td class="col65"><p class="t-hang"><em>Genesis Rabba</em> (the great midrash on Genesis)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>Lev. R.</em></p></td>
<td class="col65"><p class="t-hang"><em>Leviticus Rabba</em> (the great midrash on Leviticus)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>Num. R.</em></p></td>
<td class="col65"><p class="t-hang"><em>Numbers Rabba</em> (the great midrash on Numbers)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>Pirqe R. El.</em></p></td>
<td class="col65"><p class="t-hang"><em>Pirqe de Rabbi Eliezer</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>Sifré Num.</em></p></td>
<td class="col65"><p class="t-hang"><em>Sifré on Numbers</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>Tg. Neof.</em></p></td>
<td class="col65"><p class="t-hang"><em>Targum Neofiti</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>Tg. Ps.-J.</em></p></td>
<td class="col65"><p class="t-hang"><em>Targum Pseudo-Jonathan</em></p></td>
</tr>
</tbody>
</table>
<h1 class="sec1"><strong>VII. JEWISH WRITERS</strong></h1>
<table>
<tbody>
<tr>
<td class="col30"><p class="t-hang">Josephus</p></td>
<td class="col65"><p class="t-hang">Flavius Josephus</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><em>Ant.</em></p></td>
<td class="col65"><p class="t-hangl"><em>Jewish Antiquities</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><em>C. Ap.</em></p></td>
<td class="col65"><p class="t-hangl"><em>Contra Apion (Against Apion)</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><em>Life</em></p></td>
<td class="col65"><p class="t-hangl"><em>Life of Flavius Josephus</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><em>War</em></p></td>
<td class="col65"><p class="t-hangl"><em>The Jewish War</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Philo</p></td>
<td class="col65"><p class="t-hang">Philo Judaeus of Alexandria,</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><em>Abr.</em></p></td>
<td class="col65"><p class="t-hangl"><em>De Abrahamo (Abraham)</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><em>Aet.</em></p></td>
<td class="col65"><p class="t-hangl"><em>De aeternitate mundi (On the Eternity of the World)</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><em>Cher.</em></p></td>
<td class="col65"><p class="t-hangl"><em>De cherubim (on the Cherubim)</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><em>Conf.</em></p></td>
<td class="col65"><p class="t-hangl"><em>De confusione linguarum (On the Confusion of Tongues)</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><em>Cong.</em></p></td>
<td class="col65"><p class="t-hangl"><em>De congressu quaerendae eruditionis gratia (On Mating with the Preliminary Studies)</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><em>Decal.</em></p></td>
<td class="col65"><p class="t-hangl"><em>De decalogo (On the Decalogue)</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><em>Ebr.</em></p></td>
<td class="col65"><p class="t-hangl"><em>De ebrietate (On Drunkenness)</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><em>Fug. et inv.</em></p></td>
<td class="col65"><p class="t-hangl"><em>De fuga et inventione (On Flight and Finding)</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><em>Leg. alleg.</em></p></td>
<td class="col65"><p class="t-hangl"><em>Legum allegoriae (Allegorical Interpretation)</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><em>Migr. Abr.</em></p></td>
<td class="col65"><p class="t-hangl"><em>De migratione Abrahami (On the Migration of Abraham)</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><em>Mut.</em></p></td>
<td class="col65"><p class="t-hangl"><em>De mutatione nominum (On the Change of Names)</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><em>Opif. mundi</em></p></td>
<td class="col65"><p class="t-hangl"><em>De opificio mundi (On the Creation)</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><em>Plant.</em></p></td>
<td class="col65"><p class="t-hangl"><em>De plantatione (Concerning Noah’s Work as a Planter)</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><em>Post. Caini</em></p></td>
<td class="col65"><p class="t-hangl"><em>De posteritati Caini (Descendants of Cain)</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><a id="page_xviii"><em>Quaest. Gen.</em></a></p></td>
<td class="col65"><p class="t-hangl"><em>Questiones et solutiones in Genesin (Questions and Answers on Genesis)</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><em>Quis her.</em></p></td>
<td class="col65"><p class="t-hangl"><em>Quis rerum divinarum heres (Who Is the Heir of Divine Things)</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><em>Sacr. Abel</em></p></td>
<td class="col65"><p class="t-hangl"><em>De sacrificiis Abelis et Cain (On the Sacrifices of Abel and Cain)</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><em>Somn.</em></p></td>
<td class="col65"><p class="t-hangl"><em>De somniis (On Dreams)</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><em>Spec. leg.</em></p></td>
<td class="col65"><p class="t-hangl"><em>De specialibus legibus (The Special Laws)</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><em>Vit. Mos.</em></p></td>
<td class="col65"><p class="t-hangl"><em>De vita Moses (Life of Moses)</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Pseudo-Philo</p></td>
<td class="col65"><p class="t-hang">The <em>Biblical Antiquities</em> of Pseudo-Philo</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><em>Bib. Ant.</em></p></td>
<td class="col65"><p class="t-hang"> </p></td>
</tr>
</tbody>
</table>
<h1 class="sec1"><strong>VIII. EARLY CHRISTIAN WRITINGS</strong></h1>
<table>
<tbody>
<tr>
<td class="col30"><p class="t-hang"><em>Acts Paul</em></p></td>
<td class="col65"><p class="t-hang"><em>Acts of Paul</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>Apoc. Paul</em></p></td>
<td class="col65"><p class="t-hang"><em>Apocalypse of Paul</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>Barn.</em></p></td>
<td class="col65"><p class="t-hang"><em>Epistle of Barnabas</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>1 Clem.</em></p></td>
<td class="col65"><p class="t-hang"><em>First Epistle of Clement to the Corinthians</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>2 Clem.</em></p></td>
<td class="col65"><p class="t-hang"><em>Second Epistle of Clement to the Corinthians</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Clement of Alexandria</p></td>
<td class="col65"><p class="t-hang">Clement of Alexandria</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>Clem. Hom.</em></p></td>
<td class="col65"><p class="t-hang"><em>Pseudo-Clementine Homilies</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>Did.</em></p></td>
<td class="col65"><p class="t-hang"><em>Didache (Teaching of the Twelve Apostles)</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>Diogn.</em></p></td>
<td class="col65"><p class="t-hang"><em>Letter of Diognetus</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>Ep. Apost.</em></p></td>
<td class="col65"><p class="t-hang"><em>Epistle of the Apostles (Epistula Apostolorum)</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Eusebius</p></td>
<td class="col65"><p class="t-hang">Eusebius</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>Eccl. Hist.</em></p></td>
<td class="col65"><p class="t-hang"><em>Ecclesiastical History.</em> In some works abbreviated as <em>H.E.</em> or cited as <em>Church History</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Gnostic writings</p></td>
<td class="col65"><p class="t-hang"> </p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><em>Corp. Herm.</em></p></td>
<td class="col65"><p class="t-hangl"><em>Corpus Hermeticum</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><em>G. Thomas</em></p></td>
<td class="col65"><p class="t-hangl"><em>Gospel of Thomas</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><em>Testim. Truth</em></p></td>
<td class="col65"><p class="t-hangl"><em>The Testimony of Truth</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><em>Treat. Seth</em></p></td>
<td class="col65"><p class="t-hangl"><em>The Second Treatise of the Great Seth</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Hermas</p></td>
<td class="col65"><p class="t-hang">The Shepherd of Hermas</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><em>Man.</em></p></td>
<td class="col65"><p class="t-hangl"><em>Mandate</em> or <em>Command</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><em>Sim.</em></p></td>
<td class="col65"><p class="t-hangl"><em>Similitude</em> or <em>Parable</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><em>Vis.</em></p></td>
<td class="col65"><p class="t-hangl"><em>Vision</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Hippolytus</p></td>
<td class="col65"><p class="t-hang">Hippolytus</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><em>Apos. Trad.</em></p></td>
<td class="col65"><p class="t-hangl"><em>The Apostolic Tradition</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><a id="page_xix">Ignatius</a></p></td>
<td class="col65"><p class="t-hang">Ignatius</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><em>Eph.</em></p></td>
<td class="col65"><p class="t-hangl"><em>The Letter of Ignatius to the Church in Ephesus</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><em>Philad.</em></p></td>
<td class="col65"><p class="t-hangl"><em>The Letter of Ignatius to the Church in Philadelphia</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><em>Rom.</em></p></td>
<td class="col65"><p class="t-hangl"><em>The Letter of Ignatius to the Church in Rome</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><em>Smyrn.</em></p></td>
<td class="col65"><p class="t-hangl"><em>The Letter of Ignatius to the Church in Smyrna</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Irenaeus</p></td>
<td class="col65"><p class="t-hang">Irenaeus</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><em>Adv. haer.</em></p></td>
<td class="col65"><p class="t-hangl"><em>Adversus haereses (Against Heresies)</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Justin</p></td>
<td class="col65"><p class="t-hang">Justin Martyr</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><em>1 Apol.</em></p></td>
<td class="col65"><p class="t-hangl"><em>First Apology</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><em>2 Apol.</em></p></td>
<td class="col65"><p class="t-hangl"><em>Second Apology</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><em>Dial.</em></p></td>
<td class="col65"><p class="t-hangl"><em>Dialogue with Trypho the Jew</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>Mart. Pol.</em></p></td>
<td class="col65"><p class="t-hang"><em>Martyrdom of Polycarp</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Maximus Confessor</p></td>
<td class="col65"><p class="t-hang">Maximus Confessor</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Origen</p></td>
<td class="col65"><p class="t-hang">Origen</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><em>C. Cels.</em></p></td>
<td class="col65"><p class="t-hangl"><em>Against Celsus</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Polycarp</p></td>
<td class="col65"><p class="t-hang">Polycarp</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><em>Phil.</em></p></td>
<td class="col65"><p class="t-hangl"><em>The Letter of Polycarp to the Church in Philippi</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>Sent. Sextus</em></p></td>
<td class="col65"><p class="t-hang"><em>Sentences of Sextus</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Tatian</p></td>
<td class="col65"><p class="t-hang">Tatian</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><em>Or.</em></p></td>
<td class="col65"><p class="t-hangl"><em>Oratio</em> (<em>Oration</em> or <em>Address</em>)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Tertullian</p></td>
<td class="col65"><p class="t-hang">Tertullian</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><em>Apol.</em></p></td>
<td class="col65"><p class="t-hangl"><em>Apology</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Theophilus of Antioch</p></td>
<td class="col65"><p class="t-hang">Theophilus of Antioch</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><em>Autolycus</em></p></td>
<td class="col65"><p class="t-hangl"><em>Letter to Autolycus</em></p></td>
</tr>
</tbody>
</table>
<h1 class="sec1"><strong>IX. GREEK AND ROMAN LITERATURE</strong></h1>
<table>
<tbody>
<tr>
<td class="col30"><p class="t-hang">Aristotle</p></td>
<td class="col65"><p class="t-hang">Aristotle</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><em>Rhet.</em></p></td>
<td class="col65"><p class="t-hangl"><em>Rhetoric</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Cicero</p></td>
<td class="col65"><p class="t-hang">Cicero (Marcus Tullius Cicero)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><em>De nat. deor.</em></p></td>
<td class="col65"><p class="t-hangl"><em>De natura deorum (On the Nature of the Gods)</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Dionysius of Halicarnassus,</p></td>
<td class="col65"><p class="t-hang">Dionysius of Halicarnassus</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><em>Ant. Rom.</em></p></td>
<td class="col65"><p class="t-hangl"><em>Antiquities of Rome</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Epictetus</p></td>
<td class="col65"><p class="t-hang">Epictetus</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><em>Disc.</em></p></td>
<td class="col65"><p class="t-hangl"><em>Discourses</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Homer</p></td>
<td class="col65"><p class="t-hang">Homer</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><a id="page_xx"><em>Il.</em></a></p></td>
<td class="col65"><p class="t-hangl"><em>Iliad</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><em>Od.</em></p></td>
<td class="col65"><p class="t-hangl"><em>Odyssey</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Juvenal</p></td>
<td class="col65"><p class="t-hang">Juvenal (Decimus Iunius Iuvenalis)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Lactantius</p></td>
<td class="col65"><p class="t-hang">Lactantius</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><em>Div. Inst.</em></p></td>
<td class="col65"><p class="t-hangl"><em>Divinarum institutionum (Divine Institutions)</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Lucian</p></td>
<td class="col65"><p class="t-hang">Luciano of Samosata</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><em>Peregr.</em></p></td>
<td class="col65"><p class="t-hangl"><em>The Passing of Peregrinus</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Minucius Felix</p></td>
<td class="col65"><p class="t-hang">Minucius Felix</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><em>Oct.</em></p></td>
<td class="col65"><p class="t-hangl"><em>Octavius</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Pausanias</p></td>
<td class="col65"><p class="t-hang">Pausanias (Pausanius)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><em>Arcad.</em></p></td>
<td class="col65"><p class="t-hangl"><em>Description of Greece,</em> bk. 8: <em>Arcadia</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Plato</p></td>
<td class="col65"><p class="t-hang">Plato of Athens</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><em>Phaed.</em></p></td>
<td class="col65"><p class="t-hangl"><em>Phaedrus</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Pliny</p></td>
<td class="col65"><p class="t-hang">Pliny the Elder</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><em>Hist. Nat.</em></p></td>
<td class="col65"><p class="t-hangl"><em>Natural History</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Plutarch</p></td>
<td class="col65"><p class="t-hang">Plutarch</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><em>Mor.</em></p></td>
<td class="col65"><p class="t-hangl"><em>Moralia (Morals)</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><em>Sera numinis vindicta</em></p></td>
<td class="col65"><p class="t-hangl"><em>De sera numinis vindicta (On the Delay of Divine Justice)</em> = <em>Moralia</em> 548-68</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Severus</p></td>
<td class="col65"><p class="t-hang">Severus Iatrosophista Medicus</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hangl"><em>Clyst.</em></p></td>
<td class="col65"><p class="t-hangl"><em>De instrumentis infusoriis seu clysteribus ad Timotheum</em></p></td>
</tr>
</tbody>
</table>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 007_Abbreviations.vue?c3dea6a0